export default {
  DEFAULT_BASE_BACKEND_URL: process.env.DEFAULT_BASE_BACKEND_URL ?? 'https://seniorconnect.com.br:9010',
  LOGIN_BACKEND_URL: process.env.LOGIN_BACKEND_URL ?? 'https://seniorconnect.com.br:9010',
  TRUSTSTORE_BASE_BACKEND_URL: process.env.TRUSTSTORE_BASE_BACKEND_URL ?? 'http://teste177:9016',
  RECAPTCHA_SITEKEY: process.env.RECAPTCHA_SITEKEY ?? '',
  ENV: process.env.ENV ?? 'dev'
}
